import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { Route, RouteComponentProps, Switch } from 'react-router';
import stylesheet, { directions } from 'src/constants/stylesheet';
import Header from './Header';
import Page from './Page';

export type PartsProps =
    {
        loaded: boolean;
        openMenu: () => void;
    };

const styles = {

    parts: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        ...stylesheet.MarginGutter(1, directions.sides | directions.top),
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.7s ease-out',
        pointerEvents: 'none'
    },
    partscontent: {
        position: 'relative',
        flex: '1 1 100%',
        overflow: 'hidden'
    },
    header: {
        flex: 0,
        background: 'white',
        position: 'relative',
        zIndex: 999,
        pointerEvents: 'initial'
    },

    Subtitle_1: {
        ...stylesheet.Subtitle_1,
        textAlign: 'center',
    },
    Subtitle_2: {
        ...stylesheet.Subtitle_2,
        textAlign: 'center',
    },
    Button: {
        display: 'block',
        border: '1px solid black',
        ...stylesheet.Caption,
        transition: 'all 0.3s ease-in-out',
        padding: 15,
        '&:after': {
            content: 'initial'
        },
        '&:hover': {
            color: '#FFF',
            background: '#000',
        }
    }
};

type Props =
    PartsProps &
    StyledComponentProps<keyof typeof styles>;

type State = {
};

class Part extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this._renderPage = this._renderPage.bind(this);

        this.state = {
        };
    }

    render() {
        const { classes, openMenu, loaded } = this.props;
        return (
            <div className={classNames(classes!.parts)}>
                <Header
                    className={classNames(classes!.header)}
                    loading={!loaded}
                    openMenu={openMenu}
                />
                <div className={classNames(classes!.partscontent)}>
                    <Switch>
                        <Route render={this._renderPage} />
                    </Switch>
                </div>
            </div>);
    }

    private _renderPage(props: RouteComponentProps<any>) {
        const { loaded } = this.props;
        return <Page {...props} loaded={!!loaded} />;
    }
}

export default withStyles(styles)(Part);


// WEBPACK FOOTER //
// ./src/components/Parts.tsx